module.exports = __webpack_public_path__ + "img/work_cover.b79cd827.svg";